import React, { Component } from 'react';

class Content extends Component {
  render() {
    return (
      <div className="content">
        <h1>jacefarm</h1>

        <p>Hello, my name is Farmer.</p>

        <p>I'm a senior software engineer and manager at <a href="https://skookum.com/">Skookum Inc.</a> &ndash; <a href="https://skookum.com/services/">how can we help you</a>?</p>
        
        <p>
          Currently, I'm innovating with&nbsp;
          <a href="https://en.wikipedia.org/wiki/Domain-driven_design">Domain Driven Design</a>,&nbsp;
          <a href="https://www.typescriptlang.org/">TypeScript</a>,
          &amp; <a href="https://reactjs.org/">React</a>.
        </p>

        <p>
          I value and embody <a href="https://en.wikipedia.org/wiki/Servant_leadership">servant leadership</a>.
        </p>

        <p>
          You can message <br className="mobile-only" />
          me on <a href="https://www.linkedin.com/in/jacefarm/">LinkedIn</a>.
        </p>
        
        <p>Follow along <br className="mobile-only" />
          on <a href="https://www.instagram.com/jacefarm">Instagram</a>.
        </p>
        
        <p>Be contemplative <br className="mobile-only" />
          at <a href="https://insighttimer.com/meditation-app">Insight Timer</a>,<br />
          or prayerful <br className="mobile-only" />
          with me at  <br className="mobile-only" />
          <a href="https://universalis.com/n-apps.htm">Universalis</a>.
        </p>
      </div>
    )
  }
}

export default Content;